import React, { useCallback, useEffect, useRef, useState } from 'react';
import { IListItem } from '../../type';
import { lang } from '@umu/ukit-lang';
import { useInfiniteScroll } from 'ahooks';

interface ListLeftProps {
    dataList: IListItem[];
    isSearchMode: boolean;
    renderItem(item: any, index: number): JSX.Element;
    breadcrumbSize: { width: number; height: number } | undefined;
}

function ListLeft(props: ListLeftProps) {
    const { dataList, renderItem, isSearchMode, breadcrumbSize } = props;
    const [style, setStyle] = useState<{ [key: string]: any }>({ height: '100%' });
    const virtualListContainerRef = useRef<any>(null);
    const virtualListWrapperRef = useRef<any>(null);

    useEffect(() => {
        let height = '100%';
        if (breadcrumbSize) {
            height = `calc(100% - ${breadcrumbSize.height}px - 16px - 12px)`;
        }
        if (isSearchMode) {
            height = 'calc(100% - 12px)';
        }
        setStyle({ height });
    }, [breadcrumbSize, isSearchMode]);

    const getLoadMoreList = useCallback(
        async (nextIndex: number, limit: number) => {
            const start = nextIndex || 0;
            if (start > dataList.length - 1) {
                return {
                    list: [],
                    nextIndex: dataList.length,
                };
            }
            const end = start + limit;
            const list = dataList.slice(start, end);
            const next = dataList.length >= end ? end : dataList.length;
            return {
                list,
                nextIndex: next,
            };
        },
        [dataList],
    );

    const { data, noMore } = useInfiniteScroll((d) => getLoadMoreList(d?.nextIndex, 50), {
        target: virtualListContainerRef,
        isNoMore: (d) => {
            return d?.nextIndex === dataList.length;
        },
    });
    return (
        <div
            style={style}
            ref={virtualListContainerRef}
            className={`virtual-list-container ${isSearchMode ? 'virtual-list-container-search' : ''}`}
        >
            <div ref={virtualListWrapperRef} className="virtual-list-wrapper">
                {data?.list.map((_ele, index) => {
                    return <div key={index}>{renderItem(dataList[index], index)}</div>;
                })}
                {noMore ? <div className="not-more-data">{lang('没有更多数据了')}</div> : null}
            </div>
        </div>
    );
}

export default ListLeft;
